module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "done",
    style: ({
      display: _vm.isDone ? 'block' : 'none'
    })
  }, [_c('h2', [_vm._v("Your sprint is done!")]), _vm._v(" "), _c('p', [_vm._v("What do you want to do next?")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('action-button', {
    attrs: {
      "block": "",
      "medium": ""
    },
    on: {
      "click": _vm.newSprint
    }
  }, [_vm._v("Create another sprint")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('action-button', {
    attrs: {
      "block": "",
      "medium": ""
    },
    on: {
      "click": _vm.showStats
    }
  }, [_vm._v("Show me some stats")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a35c0a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sprint/SprintDone.vue
// module id = 541
// module chunks = 1